<template>
    <teleport to="body">
        <div class="min-h-screen bg-gray-100 p-8">
            <Teleport to="body">
                <Transition name="modal">
                    <div
                        @click.self="closeModal"
                        class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
                        role="dialog"
                        aria-labelledby="modal-title"
                        aria-modal="true"
                    >
                        <div class="bg-white rounded-lg shadow-xl w-full relative">
                            <!-- Bouton fermer -->
                            <button
                                @click="closeModal"
                                class="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600 transition-colors focus:outline-none"
                                aria-label="Fermer">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                </svg>
                            </button>

                            <div class="flex items-center justify-start p-6 md:p-4">
                                <div class="basis-1/2 flex items-center justify-end p-6 md:p-4">
                                    <img :src="fileUrl('images/loginconnexion.svg')"
                                         alt="connexion"
                                         class="w-full h-auto max-w-xl object-contain">
                                </div>
                                <div class="w-full max-w-md">
                                    <div class="mb-4 text-center">
                                        <h4 class="font-bold text-xl sm:text-2xl md:text-[28px] leading-snug">
                                            Connectez-vous à <br> votre compte ENA bibliothèque
                                        </h4>
                                    </div>

                                    <!-- Formulaire -->
                                    <form :action="submitUrl" method="post" class="space-y-5">
                                        <input type="hidden" name="_token" :value="csrfToken">
                                        <div>
                                            <label class="text-sm font-medium text-gray-700 block">Email</label>
                                            <div class="relative">
                                                <input type="email" name="email" placeholder="nom@email.com" required
                                                       class="w-full pl-4 pr-10 py-3 rounded-md border border-gray-200 focus:border-[#2A3993] focus:outline-none input-focus transition-all duration-200 text-gray-700">
                                                <!-- Icône email SVG -->
                                                <svg
                                                    class="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                          d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                                                </svg>
                                            </div>
                                        </div>

                                        <!-- Mot de passe -->
                                        <div>
                                            <label class="text-sm font-medium text-gray-700 block">Mot de passe</label>
                                            <div class="relative">
                                                <input type="password" name="password" id="passwordInput"
                                                       placeholder="••••••••••••" required
                                                       class="w-full pl-4 pr-10 py-3 rounded-md border border-gray-200 focus:border-[#2A3993] focus:outline-none input-focus transition-all duration-200 text-gray-700">
                                                <!-- Icône œil avec SVG -->
                                                <button type="button"
                                                        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors focus:outline-none">
                                                    <!-- Icône œil ouvert (visible par défaut) -->
                                                    <svg id="eyeOpen" class="w-5 h-5 hidden" fill="none" stroke="currentColor"
                                                         viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                                    </svg>
                                                    <!-- Icône œil fermé (visible par défaut car password est masqué) -->
                                                    <svg id="eyeClosed" class="w-5 h-5" fill="none" stroke="currentColor"
                                                         viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Options -->
                                        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between text-sm gap-2">
                                            <label class="flex items-center space-x-2 cursor-pointer">
                                                <input type="checkbox"
                                                       class="rounded border-gray-300 text-[#2A3993] focus:ring-[#2A3993]">
                                                <span class="text-gray-600">Se souvenir de moi</span>
                                            </label>
                                            <a href="#"
                                               class="text-gray-500 hover:text-[#1E2A78] font-medium transition-colors">
                                                Mot de passe oublié ?
                                            </a>
                                        </div>

                                        <!-- Bouton connexion -->
                                        <button type="submit"
                                                class="w-full bg-[#2A3993] text-white py-3 rounded-md font-semibold hover:bg-[#1E2A78] hover:scale-105 transition-all duration-200">
                                            Se connecter
                                        </button>

                                        <!-- Ou connexion sociale -->
                                        <div class="text-center text-gray-400 my-3">ou connectez-vous avec</div>
                                        <div class="flex justify-center gap-4">
                                            <a :href="route('social.redirect',{provider:'google'})"
                                               class="w-12 h-12 flex items-center justify-center rounded-full border border-gray-300 hover:bg-gray-100">
                                                <img :src="fileUrl('images/google.svg')" alt="Google" class="w-6 h-6">
                                            </a>
                                            <a :href="route('social.redirect',{provider:'linkedin'})"
                                               class="w-12 h-12 flex items-center justify-center rounded-full border border-gray-300 hover:bg-gray-100">
                                                <img :src="fileUrl('images/linkedin.svg')" alt="LinkedIn" class="w-6 h-6">
                                            </a>
                                            <a :href="route('social.redirect',{provider:'facebook'})"
                                               class="w-12 h-12 flex items-center justify-center rounded-full border border-gray-300 hover:bg-gray-100">
                                                <img :src="fileUrl('images/facebook.svg')" alt="Facebook" class="w-6 h-6">
                                            </a>
                                        </div>

                                        <!-- Inscription -->
                                        <div
                                            class="w-full text-center py-3 rounded-md font-semibold text-gray-600 bg-gray-200 hover:bg-gray-300 transition-all duration-200">
                                            Vous n'avez pas de compte ?
                                            <a :href="route('register',{type:''})" class="text-[#2A3993] font-medium">S'inscrire</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>
            </Teleport>
        </div>
    </teleport>
</template>

<script setup>
import {assetFile, route} from "@/helper.js";
const emit=defineEmits(['close'])
const submitUrl=route('login')
const closeModal = () => {
    emit('close',false)
}
const csrfToken = document.querySelector('meta[name="ena__verify"]').getAttribute('content')
const fileUrl=(path)=>{
    return assetFile(path)
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .bg-white,
.modal-leave-active .bg-white {
    transition: transform 0.5s ease;
}

.modal-enter-from .bg-white,
.modal-leave-to .bg-white {
    transform: scale(0.95);
}
</style>
